import svelteRetag from 'svelte-retag';

import { getCssPath } from '$entrypoints/common';
import ToastApp from '$apps/Toast-App.svelte';

let styleHref = getCssPath();

svelteRetag({
    component: ToastApp,
    tagname: 'toast-app',
    attributes: true,
    shadow: true,
    href: styleHref
});
